// Pull-quote shown on the home page (SocialProof section).
// Real quote from the book's own introduction (backend/data_pdf/Sinergie
// Generative_Manoscritto_low_def.pdf), not a fabricated user testimonial —
// PRODUCT.md explicitly forbids inventing testimonials/case studies.
export const BOOK_QUOTE = {
  it: {
    quote:
      'Un dialogo tra menti e macchine, che cerca di dimostrare come, nel profondo intreccio tra la creatività umana e le capacità di elaborazione dell’AI, possano nascere soluzioni di valore inaspettato e impatto duraturo.',
    source: 'Dal libro Sinergie Generative',
  },
  en: {
    quote:
      'A dialogue between minds and machines, seeking to show how, in the deep interplay between human creativity and AI\'s processing power, solutions of unexpected value and lasting impact can be born.',
    source: 'From the book Sinergie Generative',
  },
};
